module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAtCAMAAAByFQBZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0OTb2tvb2+vk6+vr5fDqytfQzNzU+vv61ung4eLjydLN9Pj12ufg0dHR3u7p////Cz4pqAAAAPNJREFUeNpsk8sChSAIREnNR17o///2glqJOIsWxxnAR3CzKoV7EciHyCw0nonchgf257rna0C4E57TymvjS2cYZThg6vzABoR7BNNZeMHYeNU8IZ60BkDsg897Aynf66hA69vtam/PuQ1pDmQCwuvnDzOnT3meP08LwZybDsA8zRSAaZo5YPwjYHnfg6kzNg16nPce4CajHIQ72qwwzxse9n635S43f9FzungdSfoeUeETWZ45ngYjVubXAwHi1XERf3+FBIOJDvbzK8zxjDP1if0Jtcpznhr7916ODR7v9ilckn7nfQb7XxTv/eZ/3+gvwADcFjVkPzzXsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/NH.png
// module id = F96x
// module chunks = 1